/*
  PQ001（半成品质量统计）by张帅 2020/2/20
*/
<template>
  <div class="SemiProductQuality mainWrap">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/PQ001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.nav34')}}</h1>
                <div style="float:right;display:flex;align-items: center;">
                  <label style="margin-right:10px;font-size:12px;">{{$t('StepCycleTime.labelTitle1')}}</label>
                  <!-- <el-cascader
                    class="idStyle"
                    :placeholder="$t('StepCycleTime.placehoder1')"
                    expand-trigger="hover"
                    :options="options"
                    filterable
                    @change="getTableData()"
                    v-model="machineID">
                  </el-cascader> -->
                  <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                </div>
              </div>
              <div class="tableWrap" v-loading="loading">
                 <!-- 标签页 -->
                <el-tabs type="border-card">
                  <el-tab-pane :label="$t('PQ.tabPane1')" >
                    <!-- 数据显示部分 -->
                    <div class="titileInfos">
                      <p v-if="$store.state.lang=== 1">格栅车{{treadCarNum}}统计信息</p>
                      <p v-else>Statistics of GeShanChe {{treadCarNum}}</p>
                      <div v-if="noMachine" class="noMachineTitle"></div>
                      <div class="infoWrap" v-else>
                        <span>{{$t('PQ.treadInfo.info1')+treadInfo.total}}</span>
                        <span>{{$t('PQ.treadInfo.info2')+treadInfo.qualifiedQuantity}}</span>
                        <span>{{$t('PQ.treadInfo.info3')+treadInfo.passRate}}%</span>
                        <span>{{$t('PQ.treadInfo.info4')+treadInfo.unqualifiedQuantity}}</span>
                        <span>{{$t('PQ.treadInfo.info5')+treadInfo.rejectionRate}}%</span>
                        <span>{{$t('PQ.treadInfo.info6')+treadInfo.quantityLowerTolerance}}</span>
                        <span>{{$t('PQ.treadInfo.info7')+treadInfo.percentageLowerTolerance}}%</span>
                        <span>{{$t('PQ.treadInfo.info8')+treadInfo.quantityHigherUpperTolerance}}</span>
                        <span>{{$t('PQ.treadInfo.info9')+treadInfo.percentageHigherUpperTolerance}}%</span>
                      </div>
                      <!-- 导出 -->
                      <div class="ExportBtn">
                        <el-button style="width:100px;margin-right:10px" icon="el-icon-download" @click='exportExcel'>{{$t('PQ.Export')}}</el-button>
                        <el-popover
                          placement="bottom-end"
                          width="460"
                          v-model="showPopup"
                          trigger="click">
                          <div class="selectWrap" v-loading.fullscreen.lock="fullscreenLoading">
                            <button class="timeType" :class="{'timeActive':timeType==='1'}" @click="getStatisticTreadList('1')">{{$t('PQ.yesterday')}}</button>
                            <button class="timeType" :class="{'timeActive':timeType==='2'}" @click="getStatisticTreadList('2')">{{$t('PQ.threeDays')}}</button>
                            <el-date-picker
                              class="timeselect"
                              v-model="dateValue"
                              :editable='false'
                              :clearable='false'
                              type="date"
                              value-format="yyyy-MM-dd"
                              @change="getStatisticTreadList('0')"
                            :placeholder="$t('PQ.placeholder')" >
                            </el-date-picker>
                            <!-- 格栅车列表 -->
                            <ul class='carList' >
                              <li v-for="item in statisticTreadList" :key="item.num" @click="changecar(item.num)" :class="{'active': selectActive === item.num}">{{item.licenseNumber}}</li>
                            </ul>
                          </div>
                          <el-button slot="reference" style="width:130px;padding:12px 0;" >{{$t('PQ.choseBtn')}}</el-button>
                        </el-popover>
                      </div> 
                    </div>
                    <!-- 表格显示部分 -->
                    <el-table
                      :data="treadtableData"
                      style="width: 100%"
                      :max-height='560'
                      :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                      @sort-change="highSeaOrder"
                      >
                      <el-table-column
                        :label="$t('PQ.treadTableTitle.title1')"
                        sortable="custom"
                        width="180">
                        <template slot-scope="scope">
                          <span >{{ scope.row.statisticTime | formatDate }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="dataTreadLength"
                        min-width='120'
                        :label="$t('PQ.treadTableTitle.title2')">
                      </el-table-column>
                      <el-table-column
                        min-width='140'
                        prop="licenseNumber"
                        :label="$t('PQ.treadTableTitle.title3')">
                      </el-table-column>
                      <el-table-column
                        min-width='310'
                        prop="qualifiedValue"
                        :label="$t('PQ.treadTableTitle.title4')+tolerance.standard+')'">
                      </el-table-column>
                      <el-table-column
                        width='310'
                        prop="lowerToleranceValue"
                        :label="$t('PQ.treadTableTitle.title5')+tolerance.low">
                      </el-table-column>
                      <el-table-column
                        width='310'
                        prop="upperToleranceValue"
                        :label="$t('PQ.treadTableTitle.title6')+tolerance.up">
                      </el-table-column>
                    </el-table>
                    
                  </el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane2')" :disabled='true'>零度带束层</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane3')" :disabled='true'>一号带束层</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane4')" :disabled='true'>二号带束层</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane5')" :disabled='true'>三号带束层</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane6')" :disabled='true'>四号带束层</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane7')" :disabled='true'>左子口</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane8')" :disabled='true'>右子口</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane12')" :disabled='true'>垫胶</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane9')" :disabled='true'>帘布</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane10')" :disabled='true'>胎侧</el-tab-pane>
                  <el-tab-pane :label="$t('PQ.tabPane11')" :disabled='true'>内衬层</el-tab-pane>
                </el-tabs>
              </div>       
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
// import { ElSelect } from 'element-ui/types/select'
export default {
  name: 'PQ001',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      fullscreenLoading:false,
      //  车间数据
      options: [],
      // 选中的机械id
      machineID: [Number(this.$store.state.defaultFactoryId),Number(this.$store.state.defaultId)],
      // 胎面表格数据
      treadtableData:[],
      //  胎面车号信息
      statisticTreadList:{},
      //  胎面头部表格信息
      treadInfo:{},
      // 栅格车号
      treadCarNum: '',
      // 胎面表格升降序
      treadSort: '',
      // tab的id
      tabCods: 88467,
      // loading
      loading: false,
      // 公差值
      tolerance:{
        standard:'',
        up:'',
        low:''
      },
      showPopup:false,
      // 时间选择器
      dateValue: '',
      treadTablePage:'0',
      timeType: '',
      selectActive: '0',
      saveInfo: '',
      noMachine:false
    }
  },
  created () {
    let nowDate = new Date()
    let nowformatDate = formatDate(nowDate, 'yyyy-MM-dd')
    this.dateValue= nowformatDate
  },
  mounted() {
   this.getManiceList()
   this.getStatisticTreadList('')
   this.getData()
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  filters: {
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[1]=value
      this.getTableData()
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(res.data.options !==undefined && res.data.options.length > 0 ){
            _this.noMachine=false
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options
          }else{
            // _this.options = res.data.options
            _this.noMachine=true
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 获取车号列表
    getStatisticTreadList(type) {
      let _this = this
      this.fullscreenLoading = true
      this.timeType = type
      if (type ==='1'||type ==='2') {
        this.dateValue = ''
      }
      let saveTimeType = 0
      if (_this.timeType !== '') {
        saveTimeType = _this.timeType
      }
      if (type !== '' && this.saveInfo !== `${_this.machineID[1]}-${saveTimeType}-${_this.dateValue}`) {
        this.selectActive = ''
      } else if (type !== '' && this.saveInfo === `${_this.machineID[1]}-${saveTimeType}-${_this.dateValue}`) {
        this.selectActive = _this.treadTablePage
      }
      this.axios({
        method: 'post',
        url: '/url/getStatisticTreadList',
        params:{
          machineId: _this.machineID[1],
          codes: _this.tabCods,
          startTime: _this.dateValue + ' 07:30:00',
          dayCode: _this.timeType
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.statisticTreadList = res.data.statisticTreadList
        } else {
          _this.$message.error('Machine list loading failed')
        }
        _this.fullscreenLoading = false
      })
    },
    // 获取tab里的数据
    getData(){
      let _this = this
      this.loading = true
      this.axios({
        method: 'post',
        url: '/url/selectStatisticTreadLength',
        params:{
          machineId: _this.machineID[1],
          codes: _this.tabCods,
          sort: _this.treadSort,
          page: _this.treadTablePage,
          startTime: _this.dateValue + ' 07:30:00',
          language: _this.$store.state.lang,
          dayCode: _this.timeType
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if('statisticTreadLengthForm' in res.data){
            _this.treadtableData = res.data.statisticTreadLengthList
            _this.treadInfo = res.data.statisticTreadLengthForm
            _this.treadCarNum = res.data.statisticTreadLengthList[0].licenseNumber
            _this.tolerance={
              standard: res.data.standardTreadLength,
              up: res.data.upperTolerance,
              low: res.data.lowerTolerance
            }
            let saveTimeType = 0
            if (_this.timeType !== '') {
              saveTimeType = _this.timeType
            }
            _this.saveInfo = `${_this.machineID[1]}-${saveTimeType}-${_this.dateValue}`
          }
        }else{
          _this.treadCarNum = '-'
          _this.treadtableData = []
          _this.selectActive = ''
          _this.treadInfo={
            total:0,
            qualifiedQuantity: '-',
            passRate: '-',
            unqualifiedQuantity: '-',
            rejectionRate: '-',
            quantityLowerTolerance: '-',
            percentageLowerTolerance: '-',
            quantityHigherUpperTolerance: '-',
            percentageHigherUpperTolerance: '-'
          }
          _this.tolerance={
            standard: res.data.standardTreadLength,
            up: res.data.upperTolerance,
            low: res.data.lowerTolerance
          }
          _this.saveInfo = ''
          _this.$message.error(res.data.msg)
        }
      }).then(function(){
        _this.loading = false
      })
    },
    // 切换车间重新获取数
    getTableData(){
      this.selectActive = 0
      let nowDate = new Date()
      let nowformatDate = formatDate(nowDate, 'yyyy-MM-dd')
      this.dateValue= nowformatDate
      this.getStatisticTreadList('')
      this.getData()
    },
    // 切换车号获取信息
    changecar(treadNum){
      this.treadTablePage = treadNum
      this.selectActive = treadNum
      this.getData()
      this.showPopup = false
    },
    //导出
    exportExcel(){
      if (this.treadtableData == null || this.treadtableData.length === 0){
        this.$message.error(this.$t('gantt.error'));
      }else{
        let signTime = new Date().getTime()
        let startTime = ""
        if (this.dateValue != null){
          startTime = this.dateValue + ' 07:30:00'
        }else {
          return
        }
        this.$store.commit('nowsign', signTime)
        let urlData = `?machineId=${this.machineID[1]}&codes=${this.tabCods}&startTime=${startTime}&sort=${this.treadSort}&page=${this.treadTablePage}&language=${this.$store.state.lang}&dayCode=${this.timeType}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`
        window.open('/url/selectStatisticTreadExcel' + urlData, '_blank')
      }
    },
    // 表格自定义升降序
    highSeaOrder (column) {
      if (column.order === null) {
        this.treadSort = ''
      } else if (column.order === 'descending') {
        // 降
        this.treadSort = 'desc'
      } else if (column.order ==='ascending') {
        //升
        this.treadSort = 'asc'
      }
      this.getData()
    }
    

  }
  
}
</script>
<style scoped>
.ReloadingStatistics{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 30px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.tableWrap{
  box-sizing: border-box;
  margin: 20px 15px;
}
.titileInfos{
  width: 100%;
  display: flex;
}
.titileInfos p{
  font-size: 14px;
  font-weight: bold;
  min-width: 200px;
}
.titileInfos .ExportBtn{
  width: 240px;
}
.titileInfos .infoWrap{
  flex:1;
}
.titileInfos .infoWrap span{
  font-size: 14px;
  display: inline-block;
  line-height: 25px;
  height: 25px;
  padding: 0 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.titileInfos .infoWrap span:nth-child(n+2){
  margin-left: 10px;
}
.footer{
  text-align:center;
  margin-top:20px;
}
.selectWrap{
  background-color: #fff;
}
.selectWrap .el-icon-close{
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 30px;
  color: #c0c0c0;
  cursor: pointer;
}
.selectWrap .popupTitle{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
}
.timeselect{
  float: right;
  width: 150px!important;
}
.selectWrap .carList{
  display: flex;
  margin-top: 25px;
  flex-wrap:wrap;
  max-height: 220px;
  overflow-y: auto;
}
.selectWrap .carList li, .timeType{
  text-align: center;
  width: 104px;
  height: 32px;
  line-height:32px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 2px;
  cursor: pointer;
  margin: 0 2px 10px;
  background: #fff;
}
.timeType{
   width: 100px;
}
.timeActive, .carList .active{
  color: #fff;
  background: rgba(0, 139, 213, 1)!important;
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
    flex:1;

}
</style>

